





















































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { isFunction } from 'lodash';
import { GridApi } from 'ag-grid-community';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import TimePicker from '@/reusable/Form/TimePicker.vue';
import {
  FormFieldDefMap,
  emitFormChangeEvent,
} from '@/reusable/Form/formUtils';
import moment from 'moment';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import { ConfigTiposAlerta } from '@/pantallas/Camaras/Alertas/fetchTipoAlerta';
import {
  ConfigFlotas,
  ConfigGrupos,
} from '@/pantallas/Camaras/Alertas/fetchFlota';
import { ConfigPatente } from '@/pantallas/Camaras/Alertas/fetchPatentes';

@Component({
  components: {
    DatePicker,
    TimePicker,
    FormFieldsContainer,
  },
})
export default class FiltrosBusqueda extends Vue {
  @Prop() listaTiposAlerta: ConfigTiposAlerta[];
  @Prop() listaFlotas: ConfigFlotas[];
  @Prop() listaGrupos: ConfigGrupos[];
  @Prop() listaPatentes: ConfigPatente[];
  @Prop() formFields: FormFieldDefMap;

  /*formFields: FormFieldDefMap = {
    tipoAlerta: {
      label: 'Tipo Alerta',
      id: 'tipoAlerta',
      value: '',
    },
    flota: {
      label: 'Flota',
      id: 'flota',
      value: '',
    },
    grupo: {
      label: 'Grupo',
      id: 'grupo',
      value: '',
    },
    patente: {
      label: 'Patente',
      id: 'patente',
      value: '',
    },
    velocidad: {
      label: 'Velocidad Mín.',
      id: 'velocidad',
      value: '0',
    },
    tipoFecha: {
      label: 'Tipo Fecha',
      id: 'tipoFecha',
      value: 'alerta',
      items: [],
    },
    fechaInicio: {
      label: 'Fecha Inicio',
      id: 'fechaInicio',
      value: moment(this.fechaMaxima),
    },
    fechaFin: {
      label: 'Fecha Fin',
      id: 'fechaFin',
      value: moment(this.fechaMaxima),
    },
    cantidadRegistros: {
      label: 'Cantidad Registros',
      id: 'cantidadRegistros',
      value: '',
    },
  };
  */

  async handleBuscarClick() {
    const resultadoValidacion = await this.$validator.validateAll();
    if (resultadoValidacion) {
      this.$emit('resultadoBusqueda', true);
    }
  }

  @Watch('formFields', { deep: true })
  handleFormChange(fields: FormFieldDefMap) {
    emitFormChangeEvent(this.$emit.bind(this), {
      entity: {
        fechaInicio: fields.fechaInicio.value,
        fechaFin: fields.fechaFin.value,
      } as any,
    });
  }

  changeFlota(e: any) {
    this.$emit('changeFlota', this.formFields);
  }
  changeGrupo(e: any) {
    this.$emit('changeGrupo', this.formFields);
  }

  get fechaMaxima() {
    let today = new Date();
    let dd = String(today.getDate()).padStart(2, '0');
    let mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    let yyyy = today.getFullYear();

    let fechaMax = yyyy + '-' + mm + '-' + dd;
    return fechaMax;
  }

  get fechaMaximaInicio() {
    //let fechaMax = this.formFields.fechaInicio.value;
    //console.log(fechaMax);
    //console.log(moment(this.fechaMaxima));
    return moment(this.fechaMaxima) as moment.Moment;
    //return fechaMax as moment.Moment;
  }

  get fechaMinimaInicio() {
    let fechaIni = this.formFields.fechaInicio.value;
    return fechaIni as moment.Moment;
  }

  get fechaMinima() {
    let fechaMin = moment(new Date())
      .add(-12, 'months')
      .toISOString()
      .substr(0, 10);
    return fechaMin;
  }

  clearFilters() {
    this.formFields.patente.value = '';
    this.formFields.flota.value = '';
    this.formFields.tipoAlerta.value = '';
    this.formFields.fechaInicio.value = moment(this.fechaMaxima);
    this.formFields.fechaFin.value = moment(this.fechaMaxima);
    this.formFields.cantidadRegistros.value = '';
    this.formFields.tipoFecha.value = 'alerta';
    this.formFields.velocidad.value = '0';
    this.$emit('clear');
  }
}
